
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { OnboardingData } from '../OnboardingFlow';

interface DateOfBirthStepProps {
  data: OnboardingData;
  updateData: (data: Partial<OnboardingData>) => void;
  onNext: () => void;
  onBack: () => void;
}

const DateOfBirthStep = ({ data, updateData, onNext, onBack }: DateOfBirthStepProps) => {
  const [dateOfBirth, setDateOfBirth] = useState(data.dateOfBirth);

  const handleNext = () => {
    if (dateOfBirth) {
      updateData({ dateOfBirth });
      onNext();
    }
  };

  return (
    <div className="text-center space-y-8">
      <h2 className="text-2xl font-semibold text-slate-dark font-sans">
        When's your birthday?
      </h2>
      
      <div className="space-y-6">
        <Input
          type="date"
          value={dateOfBirth}
          onChange={(e) => setDateOfBirth(e.target.value)}
          className="h-14 text-lg rounded-xl border-2 border-slate-soft focus:border-blue-primary transition-colors text-center font-sans"
          autoFocus
        />
        
        <div className="space-y-3">
          <Button
            onClick={handleNext}
            disabled={!dateOfBirth}
            className="w-full h-14 text-lg font-semibold bg-blue-primary hover:bg-blue-light disabled:bg-slate-soft disabled:cursor-not-allowed text-white rounded-xl transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98]"
          >
            Next
          </Button>
          
          <Button
            onClick={onBack}
            variant="ghost"
            className="w-full h-12 text-slate-medium hover:text-slate-dark hover:bg-slate-whisper rounded-xl transition-all duration-300 font-sans"
          >
            Back
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DateOfBirthStep;
